"use client"

import { useEffect, useState } from "react"
import { Link } from "react-router-dom"

export const useOnScreen = (ref) => {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry.isIntersecting)
      },
      { threshold: 0.5 },
    )

    if (ref.current) {
      observer.observe(ref.current)
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current)
      }
    }
  }, [ref])

  return isIntersecting
}

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen)
  }

  return (
    <nav className="text-[#222] relative">
      <div className="container mx-auto flex justify-between items-center px-4 py-6">
        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-10 text-[18px] uppercase font-semibold">
          <a href="/about" className="text-[14px] text-white">
            Team
          </a>
          <div className="relative">
            <button
              onClick={toggleDropdown}
              className="flex items-center text-[14px] text-white uppercase w-icon-dropdown-toggle gap-2"
            >
              Live@Leafwell <img src="/icons/white-dropdown.svg" alt="" className="h-[13px] flash-effect" />
            </button>
            {isDropdownOpen && (
              <div className="absolute min-w-[210px] top-[130%] mt-2 border text-[16px] text-black py-2 z-50 bg-[#ddd]">
                <a href="/build" className="block px-4 py-2">
                  Rent at Leafwell
                </a>
                <a href="/cabins" className="block px-4 py-2">
                  Your Suite
                </a>
                <a href="/booking" className="block px-4 py-2">
                  Book Events
                </a>
              </div>
            )}
          </div>
          <a href="/contact" className="text-[14px] text-white">
            Contact
          </a>
          <a href="/faqs" className="text-[14px] text-white">
            FAQs
          </a>
        </div>

        <div className="md:hidden" />

        {/* Logo */}
        <div className="absolute left-1/2 transform -translate-x-1/2">
          <Link to="/">
            <div className="p-1 rounded-xl px-2">
              {/* <img
                ref={logoRef}
                id="logo"
                src="/images/Logo.png"
                alt="Logo"
                className="max-h-[55px] md:max-h-[65px] md:max-w-full"
              /> */}
              <span className="text-[23px] font-[300] text-white font-barlow">Leafwell Farm</span>
              <div className="relative text-[32px] md:text-[60px] font-semibold leading-[100%] text-black text-center md:max-w-[8em] mb-[-0.17em] after:content-[''] after:absolute after:left-1/2 after:transform after:-translate-x-1/2 after:bottom-0 after:w-[66px] after:h-[2px] after:bg-[#fff] pb-2" />
            </div>
          </Link>
        </div>

        {/* Right options for large screens */}
        <div className="hidden md:flex items-center space-x-3 z-50">
          <a
            href="sms:3473702217"
            id="contactText"
            className="flex items-center gap-2 text-white text-sm font-semibold py-[18px] px-8 hover:px-10 hover:border-[1px] rounded-xl uppercase"
          >
            <img src="/icons/text.svg" alt="" className="h-[20px]" /> 347 370 2217
          </a>
          <Link to="/booking?event=leafwell-nature-stay">
            <button
              id="contactText"
              className="flex items-center gap-2 text-white bg-black text-sm font-semibold py-5 px-12 rounded-xl uppercase"
            >
              <img src="/icons/bell.svg" alt="" className="min-h-[20px]" /> BOOK NOW
            </button>
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <div
          className={`md:hidden flex items-center ${
            isMobileMenuOpen ? "bg-black" : "bg-[#eee]"
          } rounded-md min-h-[40px] px-3`}
        >
          <button onClick={toggleMobileMenu}>
            <svg
              className={`w-6 h-6 ${isMobileMenuOpen ? "text-white" : "text-[#222]"}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="absolute top-full left-0 right-0 mx-2 rounded-xl flex flex-col items-center py-4 text-[20px] gap-3 bg-[#0e1a23] text-white z-50">
          <div className="relative w-full flex flex-col items-center">
            <p onClick={toggleDropdown} className="px-4 py-2 flex items-center gap-2.5">
              Live@Leafwell <img src="/icons/white-dropdown.svg" alt="" className="h-[14px] flash-effect" />
            </p>
            {isDropdownOpen && (
              <div className="w-[90%] border text-black py-2 uppercase font-medium flex flex-col items-center text-[16px] bg-[#fafafa] z-50">
                <a href="/build" className="block px-4 py-2">
                  Rent at Leafwell
                </a>
                <a href="/cabins" className="block px-4 py-2">
                  Your Suite
                </a>
                <a href="/booking" className="block px-4 py-2">
                  Book Events
                </a>
              </div>
            )}
          </div>
          <a href="/contact" className="block px-4 py-2">
            Contact
          </a>
          <a href="/about" className="block px-4 py-2">
            Team
          </a>
          <a href="/faqs" className="block px-4 py-2">
            FAQs
          </a>
          <Link to="/booking?event=leafwell-nature-stay">
            <button
              id="contactText"
              className="flex items-center gap-2 text-black bg-white text-sm font-semibold py-5 px-12 rounded-xl uppercase"
            >
              <img src="/icons/black-bell.svg" alt="" className="h-[20px]" /> BOOK NOW
            </button>
          </Link>
          <a
            href="sms:3473702217"
            id="contactText"
            className="flex flex-col items-center gap-2 text-white text-sm font-semibold py-[18px] px-8 hover:px-10 hover:border-[1px] rounded-xl uppercase"
          >
            <div className="flex items-center gap-1">
              <img src="/icons/text.svg" alt="" className="h-[20px]" /> 347 370 2217{" "}
            </div>
            <span className="capitalize">Text Us</span>
          </a>
        </div>
      )}
    </nav>
  )
}

export default Header
